const ITEMS = [
  "Private Pool",
  "Panoramic Sunset Views",
  "Sleeps 24",
  "Lakeside Luxury",
  "Hot Tub Under the Stars",
  "Chef's Kitchen",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="bg-[#F1E8DA] py-8 md:py-10 overflow-hidden border-y border-[#0E2A47]/10">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif-accent italic text-2xl md:text-4xl text-[#0E2A47] px-8">
              {item}
            </span>
            <span className="text-[#1FB6C9] text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
